import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { of, zip } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { RoleDao } from '../../core/services/dao/roleDao';
import { mergeMap } from 'rxjs/operators';
import { UserDao } from '../../core/services/dao/userDao';
import { AdvertiserDao } from '../../core/services/dao/advertiserDao';
import { AgencyDao } from '../../core/services/dao/agencyDao';

@Injectable()
export class PortalResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private roleDao: RoleDao,
    private advertiserDao: AdvertiserDao,
    private agencyDao: AgencyDao,
    private userDao: UserDao
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.authService.checkSession().pipe(
      mergeMap(session => {
        let user = this.userDao.getCurrentUser();
        if (user.advertisers && user.advertisers.length > 1) {
          return this.advertiserDao.wait(adv => {
            return zip(of(adv), of(session));
          });
        } else {
          return of(session);
        }
      })
    );
  }
}
